import { LectioJSUtils } from "../LectioJSUtils";
import { SelectionDialogs } from "../SelectionDialogs";
import { EditorAttachedFilePlugin, LCDocumentEditor, LCDocumentEditorUtils, LectioEditorLinkPlugin } from "./LCDocumentEditor";
import { PluginCommentBlock2 } from "./PluginCommentBlock2";
import { EditorConfig } from "./Types";

export namespace LCDialogEditorUtils {
	export function ShowSuitableContentPicker(
		editor: CKEDITOR.editor,
		options: { folderid: SelectionDialogs.InitialFolder },
		editorConfig: EditorConfig
	): {
		promise: Promise<SelectionDialogs.ResourceSelection | undefined>;
		editorHadFocus: boolean;
	} {
		const editorHadFocus = LCDocumentEditor
			.GetEditorLectioState(editor)
			.getWasFocusInEditorBeforeCommand();

		if (editorConfig.showHomeworkPicker) {
			const resp = editorConfig.showHomeworkPicker({
				supportsHomeworkCreationMannerOptions: true,
				homeworkCreationOptionAktuelleAfsnit: editorHadFocus ? 'visible' : 'disabled',
				defaultHomeworkCreationManner: LectioJSUtils.GetNotNullValue(editorConfig.homeworkType),
				folderid: options.folderid
			});
			return { promise: resp, editorHadFocus: editorHadFocus };
		}
		{
			const resp = SelectionDialogs.ShowChooseDocumentOrEditorContentDialog({
				title: "Vælg fil", year: LCDocumentEditorUtils.Year
			}, options.folderid);

			return { promise: resp, editorHadFocus: editorHadFocus };
		}
	}

	/** Udfoerer laveste faellesnaevner for den valgte resource:
	 * Filer indsaettes som vedhaeftede filer, selvom det maatte vaere et billede eller en lydfil.
	 */
	export function ProcessNewHomeworkSelection(
		editor: CKEDITOR.editor,
		selection: SelectionDialogs.ResourceSelection,
		serverHandleNewHomeworkSelection: ((selection: SelectionDialogs.ResourceSelection) => void) | null,
		editorHadFocus: boolean
	): "error" | "client" | "server" {

		const tryInsertInEditor =
			selection.creationManner == null ||
			selection.creationManner === SelectionDialogs.HomeworkCreationManner.aktuelleAfsnit ||
			(selection.creationManner === SelectionDialogs.HomeworkCreationManner.auto && editorHadFocus);

		let canProcessInEditor = false;
		if (tryInsertInEditor) {
			const type = selection.type;
			switch (selection.type) {
			case 'createQuiz':
			case 'selectedPhaseContent':
				canProcessInEditor = false;
				break;
			case 'serializedNonFileId':
				// 20170804 RH: documentchooser via PhaseMaterialChooser skruer forloebsmateriale-ids ned i 'serializedId'...
				canProcessInEditor =
					!selection.serializedId.match(/^PH\d+/)
					&& !selection.serializedId.match(/^MA\d+/);
				break;
			case 'serializedAnyFileId':
			case 'link':
			case 'html':
				canProcessInEditor = true;
				break;
			default:
				LectioJSUtils.AssertNever(selection, type);
			}
		}
		const editorConfig = LCDocumentEditorUtils.GetEditorConfig(editor);

		if (tryInsertInEditor && canProcessInEditor) {
			editor.focus();
			if (LectioEditorLinkPlugin.GetSelectedLink(editor)) {
				alert('Kan ikke indsætte indhold: Cursoren er placeret oven i et link.');
				return 'error';
			}
			const type = selection.type;
			switch (selection.type) {
			case 'link': {
				const adjustedHref = LectioEditorLinkPlugin.GetAdjustedHref(selection.link);
				LectioEditorLinkPlugin.InsertLink(editor, selection.link, adjustedHref, selection.title);
				break;
			}
			case 'serializedAnyFileId':
				EditorAttachedFilePlugin.CreateOrUpdateAttachedFileFile(editor, selection.serializedId, selection.filename, true);
				break;
			case 'html':
				editor.insertHtml(selection.html);
				if (editorConfig.enableHomeworkHeadings)
					PluginCommentBlock2.FixHeaders(editor);
				LectioJSUtils.DispatchBrowserTestEvent('lectioembedhtml');
				break;
			case 'createQuiz':
			case 'selectedPhaseContent':
			case 'serializedNonFileId':
				throw new Error('Denne type boer ikke komme hertil. type=' + selection.type);
			default:
				LectioJSUtils.AssertNever(selection, type);
			}
			editor.fire('change');
			return 'client';
		}
		else {
			if (!serverHandleNewHomeworkSelection)
				throw new Error('Fik indhold der ikke kan haandteres paa klient, men ikke serverHandleNewHomeworkSelection?');
			serverHandleNewHomeworkSelection(selection);

			return 'server';
		}
	}
}